export type ScrollOptions = ScrollToOptions;

const DEFAULT_SCROLL_OPTIONS: ScrollOptions = {
    top: 0,
    behavior: 'smooth',
};

/**
 * Detects if we're running in a browser environment.
 */
const isClient = (): boolean => {
    return typeof window !== 'undefined' && typeof document !== 'undefined';
}

export const scrollToHeader =
    (options: ScrollOptions = DEFAULT_SCROLL_OPTIONS
    ): void => {
        if (!isClient()) return;

        window.scrollTo(options);
        document.body.style.overflow = 'visible';
    };